import { render, staticRenderFns } from "./ActionAnswerFormSubmit.vue?vue&type=template&id=709cbcf2&"
import script from "./ActionAnswerFormSubmit.vue?vue&type=script&lang=ts&"
export * from "./ActionAnswerFormSubmit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports